<ng-container [formGroup]="currentForm">
  <label class="text-lg text-blue-800 col-span-3">
    {{ label }}
  </label>
  <input
    nz-input
    class="col-span-9"
    [ngClass]="{ 'border-blue-600': !readOnly }"
    [formControlName]="attribute"
    [readOnly]="readOnly"
  />
</ng-container>
